// extracted by mini-css-extract-plugin
export var fadeInDown = "sidebar-module--fadeInDown--51bfe";
export var fadeInDropdown = "sidebar-module--fadeInDropdown--64d6f";
export var fadeInUp = "sidebar-module--fadeInUp--85a60";
export var fadeOutDropdown = "sidebar-module--fadeOutDropdown--cf676";
export var sidebar = "sidebar-module--sidebar--c6966";
export var sidebarInner = "sidebar-module--sidebarInner--6ee40";
export var sidebarWrapper = "sidebar-module--sidebarWrapper--91d47";
export var top = "sidebar-module--top--b82b8";